import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from 'primereact/progressspinner';
import { srBodyTemplate, CommonBodyForTable } from "../Common/CommonComponents";
import ApiServices from "../../service/api/ApiServices";
import { Toast } from "primereact/toast";
const saved = localStorage.getItem("user");

// Parse the saved user data from localStorage.
// This is typically used to get user information or authentication details.
const initialValue = JSON.parse(saved);

// Create an instance of ApiServices to use its methods for API calls.
// Assuming ApiServices is a class th   at handles API requests.
const apiServices = new ApiServices()

/** * CommisionDetails component to display a list of CommisionDetails in a data table.
 * It fetches the CommisionDetails data from the API and displays it in a paginated table format.
 * It also includes a search functionality to filter the CommisionDetails based on their names or other attributes.
 */
export const CommisionDetails = (props) => {

    const [ordersList, setCommisionDetailsList] = useState(null)
    const [loading, setLoading] = useState(false)

    // Create a ref for the toast component to show notifications.
    const toast = useRef(null);


    useEffect(() => {
        getCommisionDetails(props)
    }, [])

    const tableStyle = { overflowX: 'scroll', width: '100%' };

    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                <h6 className="p-mt-3 p-mr-5">Commision Details</h6>
            </span>
        </div>
    )

    /**
     * Function to fetch CommisionDetails data from the API
     * and update the state with the fetched data.
     */
    const getCommisionDetails = async (data) => {
        setLoading(true)
        setCommisionDetailsList(data.commissionDetails)
        setLoading(false)
    }

    return (

        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <Toast ref={toast} position="center" />
                        {
                            loading ?
                                <>
                                    <div className="spinner-div">
                                        <center><ProgressSpinner strokeWidth="7" animationDuration='4s' /></center>
                                    </div>
                                </>
                                :
                                <>
                                    <DataTable style={tableStyle} className="datatable-responsive" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                        value={ordersList} dataKey="id" exportFilename={`Orders_details`}
                                        loading={loading} filterDisplay="menu" header={header} >
                                        <Column field="srid" header="Sr.No." body={srBodyTemplate} style={{ width: '1rem' }} exportable={false}></Column>
                                        <Column field="sales_person_name" header="Sales Person Name" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={false}></Column>
                                        <Column field="amount" header="Amount" body={CommonBodyForTable} style={{ width: '1rem' }} exportable={false}></Column>
                                        <Column field="commission" header="Commision (%)" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={false}></Column>
                                        <Column field="sales_person_id" header="Sales Person ID" body={CommonBodyForTable} style={{ width: '1rem' }} exportable={false}></Column>
                                    </DataTable>
                                </>
                        }

                    </div>
                </div>
            </div>
        </>
    )
}